// removed by extract-text-webpack-plugin
module.exports = {"root":"cart--root--xvGEisfP","cart":"cart--cart--s5q41gKc","checkout":"cart--checkout--3sJepB5U","errors":"cart--errors--2UBj7SfY","title":"cart--title--3uvzGpNx"};


//////////////////
// WEBPACK FOOTER
// ./views/cart/styles.css
// module id = ./views/cart/styles.css
// module chunks = 0